import ModalKitchenCancelUnit from "../../../components/modals/ModalKitchenCancelUnit";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import CustomBtn from "../../../components/fragments/CustomBtn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function CheckerPage() {
  const navigate = useNavigate();
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const [testFoodList, setTestFoodList] = useState([
    { unit: 1, name: "ข้าวผัดกุ้ง" },
    {
      unit: 1,
      prevUnit: 3,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
      isFoodSuccess: 1,
    },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
      isFoodSuccess: 1,
    },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
      isFoodSuccess: 1,
    },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
      isFoodSuccess: 1,
    },
    { unit: 1, name: "ต้มยำกุ้ง", isFoodSuccess: 1 },
    { unit: 3, name: "สปาเก็ตตี้", isFoodSuccess: 1 },
    {
      unit: 3,
      name: "สลัดอกไก่",
      addOnList: ["ซอสซีซาร์ x 3"],
      ignoreList: ["ไม่ใส่งา"],
      isFoodSuccess: 1,
    },
    {
      unit: 1,
      name: "Vegan พิซซ่า",
      addOnList: ["เพิ่มเบค่อน x 2"],
      ignoreList: ["ไม่ใส่สับปะรด"],
      isFoodSuccess: 1,
    },
    {
      unit: 1,
      name: "ต้มยำกุ้งน้ำข้น",
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: ["ไม่เผ็ด"],
      isCancel: true,
      isFoodSuccess: 0,
    },
  ]);
  const [testFoodList2, setTestFoodList2] = useState([
    { unit: 1, name: "ข้าวผัดกุ้ง" },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
    },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
    },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
    },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
    },
  ]);
  const [testFoodList3, setTestFoodList3] = useState([
    { unit: 1, name: "ข้าวผัดกุ้ง" },
    {
      unit: 1,
      name: "ข้าวผัดกุ้ง",
      addOnList: ["เพิ่มข้าว"],
      ignoreList: ["ไม่ใส่ผัก"],
    },
    {
      unit: 1,
      name: "สลัดอกไก่",
      addOnList: ["ซอสซีซาร์ x 3"],
      ignoreList: ["ไม่ใส่งา"],
    },
    {
      unit: 1,
      name: "Vegan พิซซ่า",
      addOnList: ["เพิ่มเบค่อน x 2"],
      ignoreList: ["ไม่ใส่สับปะรด"],
    },
    {
      unit: 1,
      name: "ต้มยำกุ้งน้ำข้น",
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: ["ไม่เผ็ด"],
      isCancel: true,
    },
  ]);

  const [onSiteIndexList, setOnSiteIndexList] = useState([]);
  const [takeHomeIndexList, setTakeHomeIndexList] = useState([]);
  const [deliveryIndexList, setDeliveryIndexList] = useState([]);

  const [modalKitchenCancelOpen, setModalKitchenCancelOpen] = useState(false);
  const [seletedUnitsObj, setSeletedUnitsObj] = useState();

  const [isPayment, setIsPayment] = useState(true);

  const checkDisabled = (indexList, foodList, unit) => {
    if (indexList.length === 0) {
      return false;
    }

    if (unit === 1 && checkIsSelectMutiple(indexList, foodList)) {
      return false;
    }

    // if (unit > 1 && checkIsSelectMutiple(indexList, foodList)) {
    //   return true;
    // }

    if (unit === 1 && !checkIsSelectMutiple(indexList, foodList)) {
      return true;
    }

    if (unit > 1 && checkIsSelectMutiple(indexList, foodList)) {
      return false;
    }
  };

  const checkIsSelectMutiple = (indexList, foodList) => {
    var isSelectMultiple = false;

    for (let v of indexList) {
      if (foodList[v] && foodList[v].unit === 1) {
        return true;
      }
    }

    return isSelectMultiple;
  };

  const checkClearAllTakeHome = () => {
    return takeHomeIndexList.length === testFoodList2.filter((v) => !v.isCancel && !v.isServ).length;
  };

  const clearAllTakeHome = () => {
    setTestFoodList2((prev) => {
      const newList = [...prev];
      newList.map((v) => (v.isServ = true));
      return newList;
    });
    setTakeHomeIndexList([]);
  };

  return (
    <>
      {/* header */}

      {/* body */}
      <div className="flex gap-[min(2.15vw,22px)] px-[min(1.56vw,16px)]  pt-[min(1.56vw,16px)] pb-[min(7.13vw,73px)]">
        {/* onsite */}
        <div className="shadow-2-8 w-[min(28.81vw,295px)] bg-[#FFF] h-fit rounded-[10px] ">
          <div className="rounded-t-[min(0.39vw,4px)] flex  justify-between  pl-[min(1.37vw,14px)] mb-2 pr-[min(0.39vw,10px)] pt-[10px] pb-[min(0.68vw,7px)]">
            <div className="flex flex-wrap  w-100 items-center gap-[min(1.17vw,12px)]">
              <img className="object-contain aspect-square w-[min(6.54vw,40px)] h-fit" src="/img/icons/icon-kitchen-onsite.png" alt="" />
              <div className=" font-[500]">
                <div className="text-[14px] text-[#373737] lh-1">ทานที่ร้าน</div>
                <div className="font-[500]">
                  <span className="text-[12px] text-[#2CC56F]">ในร้าน A14</span>
                  <span className="text-[10px] text-[#37474F]/[0.7] ml-2">เวลา 12:00:12</span>
                </div>
              </div>
              {isPayment ? <div className="text-[#2DC76D] text-[10px] rounded-xl bg-[#DCFFEB] px-2 py-1 lh-1 ml-auto">ชำระเงินแล้ว</div> : ""}
            </div>
          </div>

          <div className="flex items-center text-[10px] text-[#37474F]/[0.7] pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">
            <div className="mr-1">Order 2020052510102</div>
            <div className="ml-auto mr-2">POS 1</div>
            <div>00:07:35</div>
          </div>

          <div className="font-semibold text-sm pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">รายการอาหาร</div>

          <div className="overflow-y-auto flex flex-col gap-[min(1.56vw,16px)] max-h-[min(43.65vw,447px)] px-[min(1.95vw,20px)] pt-[min(1.95vw,20px)] pb-[min(3.32vw,34px)]">
            {testFoodList.map((value, index) => {
              return (
                !value.isServ && (
                  <FoodChild
                    key={index}
                    index={index}
                    info={value}
                    selectedIndexList={onSiteIndexList}
                    setSelectedList={setOnSiteIndexList}
                    foodList={testFoodList}
                    setFoodList={setTestFoodList}
                    isCancel={value.isCancel}
                    isDisabled={checkDisabled(onSiteIndexList, testFoodList, value.unit)}
                    isSelectOneMode={!checkIsSelectMutiple(onSiteIndexList, testFoodList)}
                    setSeletedUnitsObj={setSeletedUnitsObj}
                  />
                )
              );
            })}
          </div>
          {/* footer */}
          <FooterCard
            selectedList={onSiteIndexList}
            setSelectedList={setOnSiteIndexList}
            setFoodList={setTestFoodList}
            checkIsSelectMutiple={checkIsSelectMutiple}
            setModalKitchenCancelOpen={setModalKitchenCancelOpen}
            foodList={testFoodList}
            isPayment={isPayment}
          />
        </div>

        {/* takehome */}
        <div className="shadow-2-8 w-[min(28.81vw,295px)] bg-[#FFF] h-fit rounded-[10px] ">
          <div className="rounded-t-[min(0.39vw,4px)] flex  justify-between  pl-[min(1.37vw,14px)] mb-2 pr-[min(0.39vw,10px)] pt-[10px] pb-[min(0.68vw,7px)]">
            <div className="flex flex-wrap  w-100 items-center gap-[min(1.17vw,12px)]">
              <img className="object-contain aspect-square w-[min(6.54vw,40px)] h-fit" src="/img/icons/icon-kitchen-take-home.png" alt="" />
              <div className=" font-[500]">
                <div className="text-[14px] text-[#373737] lh-1">ซื้อกลับบ้าน</div>
                <div className="font-[500]">
                  <span className="text-[12px] text-[#2CC56F]">คิวที่ 15</span>
                  <span className="text-[10px] text-[#37474F]/[0.7] ml-2">เวลา 12:00:12</span>
                </div>
              </div>
              {isPayment ? <div className="text-[#2DC76D] text-[10px] rounded-xl bg-[#DCFFEB] px-2 py-1 lh-1 ml-auto">ชำระเงินแล้ว</div> : ""}
            </div>
          </div>

          <div className="flex items-center text-[10px] text-[#37474F]/[0.7] pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">
            <div className="mr-1">Order 2020052510102</div>
            <div className="ml-auto mr-2">POS 1</div>
            <div>00:07:35</div>
          </div>

          <div className="font-semibold text-sm pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">รายการอาหาร</div>

          <div className="overflow-y-auto flex flex-col gap-[min(1.56vw,16px)] max-h-[min(43.65vw,447px)] px-[min(1.95vw,20px)] pt-[min(1.95vw,20px)] pb-[min(3.32vw,34px)]">
            {testFoodList2.map((value, index) => {
              return (
                !value.isServ && (
                  <FoodChild
                    key={index}
                    index={index}
                    info={value}
                    isCancel={value.isCancel}
                    foodList={testFoodList2}
                    setSelectedList={setTakeHomeIndexList}
                    setFoodList={setTestFoodList2}
                    isDisabled={checkDisabled(takeHomeIndexList, testFoodList2, value.unit)}
                    selectedIndexList={takeHomeIndexList}
                    setSeletedUnitsObj={setSeletedUnitsObj}
                    isSelectOneMode={!checkIsSelectMutiple(takeHomeIndexList, testFoodList2)}
                  />
                )
              );
            })}
          </div>
          {/* footer */}
          <FooterCard
            selectedList={takeHomeIndexList}
            setSelectedList={setTakeHomeIndexList}
            setFoodList={setTestFoodList2}
            checkIsSelectMutiple={checkIsSelectMutiple}
            setModalKitchenCancelOpen={setModalKitchenCancelOpen}
            foodList={testFoodList2}
            isPayment={isPayment}
          />
        </div>

        {/* delivery */}
        <div className="shadow-2-8 w-[min(28.81vw,295px)] h-fit bg-[#FFF] rounded-[10px] ">
          <div className="rounded-t-[min(0.39vw,4px)] flex  justify-between  pl-[min(1.37vw,14px)] mb-2 pr-[min(0.39vw,10px)] pt-[10px] pb-[min(0.68vw,7px)]">
            <div className="flex flex-wrap  w-100 items-center gap-[min(1.17vw,12px)]">
              <img className="object-contain aspect-square w-[min(6.54vw,40px)] h-fit" src="/img/icons/icon-kitchen-delivery.png" alt="" />
              <div className=" font-[500]">
                <div className="text-[14px] text-[#373737] lh-1">ซื้อกลับบ้าน</div>
                <div className="font-[500]">
                  <span className="text-[12px] text-[#2CC56F]">คิวที่ 15</span>
                  <span className="text-[10px] text-[#37474F]/[0.7] ml-2">เวลา 12:00:12</span>
                </div>
              </div>
              {isPayment ? <div className="text-[#2DC76D] text-[10px] rounded-xl bg-[#DCFFEB] px-2 py-1 lh-1 ml-auto">ชำระเงินแล้ว</div> : ""}
            </div>
          </div>

          <div className="flex items-center text-[10px] text-[#37474F]/[0.7] pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">
            <div className="mr-1">Order 2020052510102</div>
            <div className="ml-auto mr-2">POS 1</div>
            <div>00:07:35</div>
          </div>

          <div className="font-semibold text-sm pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">รายการอาหาร</div>

          <div className="overflow-y-auto flex flex-col gap-[min(1.56vw,16px)] max-h-[min(43.65vw,447px)] px-[min(1.95vw,20px)] pt-[min(1.95vw,20px)] pb-[min(3.32vw,34px)]">
            {testFoodList3.map((value, index) => {
              return (
                !value.isServ && (
                  <FoodChild
                    key={index}
                    index={index}
                    name={"delivery"}
                    info={value}
                    isCancel={value.isCancel}
                    setSelectedList={setDeliveryIndexList}
                    foodList={testFoodList3}
                    setFoodList={setTestFoodList3}
                    isDisabled={checkDisabled(deliveryIndexList, testFoodList3, value.unit)}
                    selectedIndexList={deliveryIndexList}
                    setSeletedUnitsObj={setSeletedUnitsObj}
                    isSelectOneMode={!checkIsSelectMutiple(deliveryIndexList, testFoodList3)}
                  />
                )
              );
            })}
          </div>
          {/* footer */}
          <FooterCard
            selectedList={deliveryIndexList}
            setSelectedList={setDeliveryIndexList}
            setFoodList={setTestFoodList3}
            checkIsSelectMutiple={checkIsSelectMutiple}
            setModalKitchenCancelOpen={setModalKitchenCancelOpen}
            foodList={testFoodList3}
            isPayment={isPayment}
          />
        </div>
      </div>

      <ModalKitchenCancelUnit
        modalOpenObj={{
          modalOpen: modalKitchenCancelOpen,
          setModalOpen: setModalKitchenCancelOpen,
        }}
        seletedUnitsObj={seletedUnitsObj}
      />
    </>
  );
}

function FoodChild({ selectedIndexList, setSelectedList, foodList, setFoodList, setSeletedUnitsObj, index, info, isCancel = false, isDisabled = false, isSelectOneMode = false }) {
  const [isServ, setIsServ] = useState(false);
  const [icon, setIcon] = useState("/img/icons/icon-serv-grey.svg");
  const [colorIcon, setColor] = useState("#b6bbc6");
  useEffect(() => {
    if (isCancel) {
      return setIcon("/img/icons/icon-serv-red.svg");
    }
    if (selectedIndexList.includes(index)) {
      setColor("#12C219");
      return setIcon("/img/icons/icon-serv-green.svg");
    }
    setIcon("/img/icons/icon-serv-grey.svg");
    setColor("#b6bbc6");
  }, [selectedIndexList, isCancel]);

  return (
    <div>
      <div className={`flex justify-between text-[#4A4A4A] text-18 ${isDisabled && !isCancel ? "pointer-events-none opacity-50" : ""}`}>
        <div className="flex leading-[1.2]">
          <div className={`kitchen-input-checkbox w-fit mr-[min(1.46vw,15px)] h-fit ${isCancel ? "opacity-0 pointer-events-none" : ""}`}>
            <input
              type="checkbox"
              checked={selectedIndexList.includes(index)}
              onChange={() => {
                setIsServ(!isServ);
                if (isSelectOneMode) {
                  return setSelectedList((prev) => {
                    if (prev.includes(index)) {
                      return [];
                    }
                    setSeletedUnitsObj({
                      foodList: foodList,
                      setFoodList: setFoodList,
                      selectIndex: index,
                      setSelectedList: setSelectedList,
                    });
                    return [index];
                  });
                }
                setSelectedList((prev) => {
                  const oldList = [...prev];
                  if (oldList.includes(index)) {
                    return oldList.filter((item) => item !== index);
                  }
                  return [...oldList, index];
                });
              }}
            />
            <label></label>
          </div>
          <div
            className={`mr-[min(1.76vw,18px)] text-[14px] font-[500] ${selectedIndexList.includes(index) || isCancel ? "line-through" : ""} ${
              info.prevUnit ? "text-[var(--color-red)]" : ""
            } relative`}
          >
            {info.unit} x{info.prevUnit && <div className="absolute top-[calc(min(0.78vw,8px)*-1)] right-[calc(min(0.59vw,6px)*-1)] text-12 text-black">{info.prevUnit} x</div>}
          </div>
          <div className="flex flex-col gap-[min(0.29vw,3px)]">
            <div className={`text-[14px] font-[500] ${selectedIndexList.includes(index) || isCancel ? "line-through" : ""}`}>{info.name}</div>
            {info &&
              info.addOnList &&
              info.addOnList.map((value, index) => {
                return (
                  <div
                    key={index}
                    className="text-12 min-w-[min(6.15vw,63px)] h-[min(1.76vw,18px)] px-[min(0.29vw,3px)] text-[var(--color-red)] bg-[var(--color-light-red)] rounded-[min(0.20vw,2px)] flex items-center"
                  >
                    {value}
                  </div>
                );
              })}
            {info &&
              info.ignoreList &&
              info.ignoreList.map((value, index) => {
                return (
                  <div
                    key={index}
                    className="text-12 w-fit h-[min(1.76vw,18px)] px-[min(0.29vw,3px)] text-[var(--color-orange)] bg-[var(--color-light-orange)] rounded-[min(0.20vw,2px)] flex items-center"
                  >
                    {value}
                  </div>
                );
              })}
          </div>
        </div>
        <div
          className={`${selectedIndexList.includes(index) ? "cursor-pointer" : "pointer-events-none"}`}
          onClick={() => {
            setFoodList((prev) => {
              const newList = [...prev];
              if (newList.length > index) {
                newList[index].isServ = true;
              }
              return newList;
            });
            setSelectedList((prev) => {
              const newList = [...prev];
              if (newList.includes(index)) {
                return newList.filter((v) => v !== index);
              }
              return newList;
            });
          }}
        >
          <img className={`object-contain aspect-square w-[min(2.13vw,21.82px)] h-fit`} src={icon} alt="" />
        </div>
      </div>
      <div className="flex items-center mt-2">
        {info.isFoodSuccess ? (
          <>
            {" "}
            <CheckCircleIcon className="!text-[#409FFB] !text-[16px] !mr-1 mt-[-1px]" /> <span className="text-[9px]"> อาหารเสร็จแล้ว</span>{" "}
          </>
        ) : (
          ""
        )}

        <div className="ml-auto shadow rounded-full px-2 font-bold pb-[4px] pt-[2px] lh-1">
          <CheckCircleIcon className={`!text-[${colorIcon}] !text-[16px]  !mr-[1px] mt-[-1px]`} /> <span className="text-[10px]">เช็คแล้ว</span>
        </div>
      </div>
    </div>
  );
}

function FooterCard({ selectedList, setSelectedList, setFoodList, checkIsSelectMutiple, setModalKitchenCancelOpen, foodList, isPayment }) {
  const [isClearOpen, setIsClearOpen] = useState(false);
  const [isBtnActive, setIsBtnActive] = useState(false);

  const foodListActive = foodList && foodList.filter((item) => !item.isCancel);

  useEffect(() => {
    if (foodListActive && foodListActive.length == selectedList.length && isPayment) {
      return setIsBtnActive(true);
    }
    setIsBtnActive(false);
  }, [selectedList]);

  return (
    <div className="px-[min(1.95vw,20px)] rounded-b-[min(0.39vw,4px)]">
      <div className="text-center">
        <CustomBtn
          onClick={() => {}}
          className={`leading-[0.8] px-3 text-white font-[400] text-14 min-h-[min(3.51vw,36px)] rounded-[min(0.58vw,6px)] mt-[min(1.56vw,16px)] mb-[min(0.98vw,10px)] ${
            isBtnActive ? "btn-main-active" : "disabled-btn"
          }`}
          btntxt={"ปิดรายการ"}
        />
      </div>
      <div className=" pt-[min(0.98vw,10px)]"></div>
    </div>
  );
}
